import { useState, useEffect } from 'react'
import API from 'api'

export default function getActivitesByType(type, coords, params = {}) {
  const [isLoading, setLoading] = useState(true)
  const [items, setItems] = useState([])

  const options = {
    uniq_activity: true,
    point: coords ? `${coords.latitude},${coords.longitude}` : undefined,
    ...params,
  }

  useEffect(() => {
    getData(options)
  }, [])

  const getData = (coords) => {
    API(`/api/adventure/v1/search/${type}/nearby/`)
      .get(coords)
      .then((data) => {
        setItems(data.results || data)
        setLoading(false)
      })
  }

  return { items, isLoading }
}
